export default function Tag({selected, name, onClick, size='large'}) {
  return (
    <span className={`block tag is-info is-${size} ${selected ? 'is-light':''}`} 
      onClick={()=> onClick(name)}>
        {name}
    </span>
  )
}